import gql from 'graphql-tag'

export default gql`
  query GetProductCollection($slug: String!) {
    cfProductCollectionCollection(limit: 1, where: { slug: $slug }) {
      items {
        title
        bodyCopy
        shortDescription
        heroImageSet {
          masterSupportingColour
          master {
            url
          }
        }
        products: productSearchResults {
          variantGroupCode
          name
          brand {
            name
          }
          image
          otherVariants {
            sku
            price {
              effectivePrice
              originalPrice
              discountedPrice
            }
            onSale
          }
          shop {
            id
            name
            retailer {
              sys {
                id
              }
            }
          }
          issues {
            type
            severity
          }
        }
      }
    }
  }
`
